const messages = {
  title: "Accesso negato",
  description: "Non hai accesso a questa risorsa.",
  backHomeButton: "Torna alla dashboard",
}

export default {
  messages
}
